import { useEffect } from "react";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Check, CalendarCheck } from "lucide-react";
import logoUrl from "@/assets/waiterix-logo.png";
import { Link } from "wouter";

export default function ThankYou() {
    useEffect(() => {
        // Trigger conversion event for Google Ads
        if (typeof window.gtag === 'function') {
            window.gtag('event', 'conversion', {
                'send_to': 'AW-18180332491/DGbMCJKFuLUcEMu3h91D'
            });
            console.log("[Google Ads] Conversion event fired");
        }
    }, []);

    return (
        <div className="min-h-screen bg-background flex flex-col">
            {/* Header */}
            <header className="border-b glass backdrop-blur-sm sticky top-0 z-50">
                <div className="max-w-7xl mx-auto px-4 py-4 flex items-center justify-between">
                    <Link href="/landing" className="flex items-center gap-3">
                        <img src={logoUrl} alt="Waiterix" className="h-10 hover-lift smooth-transition" />
                    </Link>
                </div>
            </header>

            {/* Main Content */}
            <main className="flex-1 flex items-center justify-center py-16 px-4 relative overflow-hidden">
                {/* Background decorations */}
                <div className="absolute inset-0 bg-gradient-to-br from-primary/10 via-transparent to-orange-400/10"></div>
                <div className="absolute top-20 left-10 w-32 h-32 bg-primary/10 rounded-full blur-3xl float"></div>
                <div className="absolute bottom-20 right-10 w-48 h-48 bg-orange-400/10 rounded-full blur-3xl float-delayed"></div>

                <Card className="glass-card shadow-2xl max-w-lg w-full p-8 md:p-12 text-center relative z-10">
                    {/* Success Icon */}
                    <div className="mx-auto w-20 h-20 rounded-full bg-gradient-to-br from-primary/20 to-primary/10 border-2 border-primary/30 flex items-center justify-center mb-6">
                        <CalendarCheck className="h-10 w-10 text-primary" />
                    </div>

                    {/* Heading */}
                    <h1 className="text-3xl md:text-4xl font-bold mb-4">
                        Thank You!
                    </h1>

                    {/* Message */}
                    <p className="text-lg text-muted-foreground mb-6 leading-relaxed">
                        Thank you for booking your meeting. We look forward to speaking with you.
                    </p>

                    {/* Confirmation badge */}
                    <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-primary/10 border border-primary/20 text-sm font-medium mb-8">
                        <Check className="h-4 w-4 text-primary" />
                        <span>Your meeting is confirmed</span>
                    </div>

                    {/* CTA */}
                    <div className="space-y-3">
                        <Link href="/landing">
                            <Button className="w-full btn-glow shadow-glow hover-lift">
                                Back to Waiterix
                            </Button>
                        </Link>
                    </div>
                </Card>
            </main>

            {/* Footer */}
            <footer className="border-t py-6 bg-muted/30">
                <div className="max-w-7xl mx-auto px-4 text-center">
                    <p className="text-sm text-muted-foreground">
                        © 2025 Waiterix. All rights reserved. A product of Harmonia Enterprises LLC.
                    </p>
                </div>
            </footer>
        </div>
    );
}
